import React, {PureComponent} from "react"
import {connect} from "react-redux"

import {AccordionItem} from "@irati/ui/src/Accordion"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {ReduxState} from "@irati/store/types"

import FeaturesContent from "./FeaturesContent"

interface Props extends InjectIntl {
  isMobile: boolean
}

class AppFeatures extends PureComponent<Props> {
  appFeaturesAccordion = React.createRef()

  toggleAccordion = () => {
    const shouldOpen = !this.appFeaturesAccordion.current.state.isExpanded

    if (shouldOpen) {
      this.appFeaturesAccordion.current.open()
    } else {
      this.appFeaturesAccordion.current.close()
    }
  }

  render() {
    const {formatMessage, isMobile} = this.props
    if (isMobile) {
      return (
        <div onClick={() => this.toggleAccordion()}>
          <AccordionItem
            ref={this.appFeaturesAccordion}
            title={formatMessage({id: "medical.activation.appFeatures.title"})}>
            <FeaturesContent />
          </AccordionItem>
        </div>
      )
    }
    return <FeaturesContent />
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isMobile: mq.lessThan.medium
})

export default injectIntl(connect(mapStateToProps)(AppFeatures))
